import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {SiteProviderModel} from "../../models/site-provider.model";
import {
  isPredictionProviderType,
  siteProviderTypeLabelKey
} from "../../constants/site-provider-types.constant";

require('./site-providers-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-site-providers-table-row',
  templateUrl: './site-providers-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteProvidersTableRowComponent {

  @Input() provider: SiteProviderModel;

  @Output() onEdit = new EventEmitter<void>();
  @Output() onArchive = new EventEmitter<void>();
  /** Emits the state the switch was moved to, saved as the provider's `active`. */
  @Output() onActiveChange = new EventEmitter<boolean>();

  get isPrediction(): boolean {
    return isPredictionProviderType(this.provider.providerType);
  }

  // Same translation group the Add/Edit dialog's type picker reads, so a type reads the same in
  // both places.
  get typeLabelKey(): string {
    return siteProviderTypeLabelKey(this.provider.providerKind, this.provider.providerType);
  }

  get isActive(): boolean {
    return this.provider.active;
  }

  // Shows the identifying detail of whichever source applies: the model endpoint for a prediction
  // provider, the BigQuery dataset/table for a projection one.
  get resolverSummary(): string {
    if (this.isPrediction) {
      return this.provider.endpointId || '-';
    }
    return this.provider.dataset && this.provider.table
      ? `${this.provider.dataset} / ${this.provider.table}`
      : '-';
  }

}
